import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string };
};

export type AiFilters = {
  __typename?: 'AIFilters';
  date_and_time?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  task?: Maybe<Scalars['String']['output']>;
  text_cleanup?: Maybe<Scalars['String']['output']>;
};

export type AddToLiveMeeting = {
  __typename?: 'AddToLiveMeeting';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Analytics = {
  __typename?: 'Analytics';
  team: TeamAnalytics;
  users: Array<UserAnalytics>;
};

export type AnalyticsCategories = {
  __typename?: 'AnalyticsCategories';
  date_times?: Maybe<Scalars['Int']['output']>;
  metrics?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Scalars['Int']['output']>;
  tasks?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsSpeaker = {
  __typename?: 'AnalyticsSpeaker';
  duration?: Maybe<Scalars['Float']['output']>;
  duration_pct?: Maybe<Scalars['Float']['output']>;
  filler_words?: Maybe<Scalars['Int']['output']>;
  longest_monologue?: Maybe<Scalars['Float']['output']>;
  monologues_count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['Int']['output']>;
  speaker_id?: Maybe<Scalars['Int']['output']>;
  word_count?: Maybe<Scalars['Int']['output']>;
  words_per_minute?: Maybe<Scalars['Float']['output']>;
};

export type AppOutput = {
  __typename?: 'AppOutput';
  app_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transcript_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type Apps = {
  __typename?: 'Apps';
  outputs?: Maybe<Array<AppOutput>>;
};

export type AttendeeInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AudioUploadInput = {
  attendees?: InputMaybe<Array<AttendeeInput>>;
  bypass_size_check?: InputMaybe<Scalars['Boolean']['input']>;
  client_reference_id?: InputMaybe<Scalars['String']['input']>;
  custom_language?: InputMaybe<Scalars['String']['input']>;
  save_video?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  webhook?: InputMaybe<Scalars['String']['input']>;
};

export type AudioUploadStatus = {
  __typename?: 'AudioUploadStatus';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type Bite = {
  __typename?: 'Bite';
  captions?: Maybe<Array<BiteCaption>>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_from?: Maybe<BiteOrigin>;
  end_time: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  media_type?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  privacies: Array<BitePrivacy>;
  sources?: Maybe<Array<MediaSource>>;
  start_time: Scalars['Float']['output'];
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  summary_status?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  transcript_id: Scalars['String']['output'];
  user: BiteUser;
  user_id: Scalars['String']['output'];
};

export type BiteCaption = {
  __typename?: 'BiteCaption';
  end_time: Scalars['Float']['output'];
  index: Scalars['Int']['output'];
  speaker_id: Scalars['String']['output'];
  speaker_name: Scalars['String']['output'];
  start_time: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

export type BiteOrigin = {
  __typename?: 'BiteOrigin';
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: BiteOriginType;
};

export enum BiteOriginType {
  Meeting = 'MEETING'
}

export enum BitePrivacy {
  Participants = 'participants',
  Public = 'public',
  Team = 'team'
}

export type BiteUser = {
  __typename?: 'BiteUser';
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
};

export type MediaSource = {
  __typename?: 'MediaSource';
  src: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MeetingAnalytics = {
  __typename?: 'MeetingAnalytics';
  categories?: Maybe<AnalyticsCategories>;
  sentiments?: Maybe<Sentiments>;
  speakers?: Maybe<Array<AnalyticsSpeaker>>;
};

export type MeetingAttendeeModel = {
  __typename?: 'MeetingAttendeeModel';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type MeetingInfo = {
  __typename?: 'MeetingInfo';
  fred_joined?: Maybe<Scalars['Boolean']['output']>;
  silent_meeting?: Maybe<Scalars['Boolean']['output']>;
  summary_status?: Maybe<SummaryStatus>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addToLiveMeeting: AddToLiveMeeting;
  createBite: Bite;
  deleteTranscript: Transcript;
  setUserRole: User;
  updateMeetingTitle: Transcript;
  uploadAudio: AudioUploadStatus;
};

export type MutationAddToLiveMeetingArgs = {
  attendees?: InputMaybe<Array<AttendeeInput>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  meeting_link: Scalars['String']['input'];
  meeting_password?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateBiteArgs = {
  end_time: Scalars['Float']['input'];
  media_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacies?: InputMaybe<Array<BitePrivacy>>;
  start_time: Scalars['Float']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  transcript_Id: Scalars['ID']['input'];
};

export type MutationDeleteTranscriptArgs = {
  id: Scalars['String']['input'];
};

export type MutationSetUserRoleArgs = {
  role: Role;
  user_id: Scalars['String']['input'];
};

export type MutationUpdateMeetingTitleArgs = {
  input: UpdateMeetingTitleInput;
};

export type MutationUploadAudioArgs = {
  input?: InputMaybe<AudioUploadInput>;
};

export type Query = {
  __typename?: 'Query';
  analytics: Analytics;
  apps?: Maybe<Apps>;
  bite?: Maybe<Bite>;
  bites: Array<Bite>;
  transcript?: Maybe<Transcript>;
  transcripts?: Maybe<Array<Transcript>>;
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
};

export type QueryAnalyticsArgs = {
  end_time?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAppsArgs = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  transcript_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBiteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryBitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  my_team?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  transcript_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTranscriptArgs = {
  id: Scalars['String']['input'];
};

export type QueryTranscriptsArgs = {
  date?: InputMaybe<Scalars['Float']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  host_email?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  organizer_email?: InputMaybe<Scalars['String']['input']>;
  participant_email?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum Role {
  Admin = 'admin',
  User = 'user'
}

export type Sentence = {
  __typename?: 'Sentence';
  ai_filters?: Maybe<AiFilters>;
  end_time?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  raw_text?: Maybe<Scalars['String']['output']>;
  speaker_id?: Maybe<Scalars['Int']['output']>;
  speaker_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Sentiments = {
  __typename?: 'Sentiments';
  negative_pct?: Maybe<Scalars['Float']['output']>;
  neutral_pct?: Maybe<Scalars['Float']['output']>;
  positive_pct?: Maybe<Scalars['Float']['output']>;
};

export type Speaker = {
  __typename?: 'Speaker';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Summary = {
  __typename?: 'Summary';
  action_items?: Maybe<Scalars['String']['output']>;
  bullet_gist?: Maybe<Scalars['String']['output']>;
  extended_sections?: Maybe<Array<SummarySection>>;
  gist?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  meeting_type?: Maybe<Scalars['String']['output']>;
  outline?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  short_overview?: Maybe<Scalars['String']['output']>;
  short_summary?: Maybe<Scalars['String']['output']>;
  shorthand_bullet?: Maybe<Scalars['String']['output']>;
  topics_discussed?: Maybe<Array<Scalars['String']['output']>>;
  transcript_chapters?: Maybe<Array<Scalars['String']['output']>>;
};

export type SummarySection = {
  __typename?: 'SummarySection';
  content: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum SummaryStatus {
  Default = 'default',
  Failed = 'failed',
  Processed = 'processed',
  Processing = 'processing',
  Skipped = 'skipped'
}

export type TeamAnalytics = {
  __typename?: 'TeamAnalytics';
  conversation: TeamConversationStats;
  meeting: TeamMeetingStats;
};

export type TeamConversationStats = {
  __typename?: 'TeamConversationStats';
  average_filler_words: Scalars['Int']['output'];
  average_filler_words_diff_pct?: Maybe<Scalars['Int']['output']>;
  average_monologues_count: Scalars['Int']['output'];
  average_monologues_count_diff_pct?: Maybe<Scalars['Int']['output']>;
  average_questions: Scalars['Int']['output'];
  average_questions_diff_pct?: Maybe<Scalars['Int']['output']>;
  average_sentiments: Sentiments;
  average_silence_duration: Scalars['Float']['output'];
  average_silence_duration_diff_pct?: Maybe<Scalars['Int']['output']>;
  average_talk_listen_ratio: Scalars['Float']['output'];
  average_words_per_minute: Scalars['Float']['output'];
  longest_monologue_duration_diff_pct?: Maybe<Scalars['Int']['output']>;
  longest_monologue_duration_sec: Scalars['Int']['output'];
  teammates_count: Scalars['Int']['output'];
  total_filler_words: Scalars['Int']['output'];
  total_filler_words_diff_pct?: Maybe<Scalars['Int']['output']>;
  total_meeting_notes_count: Scalars['Int']['output'];
  total_meetings_count: Scalars['Int']['output'];
  total_monologues_count: Scalars['Int']['output'];
  total_monologues_diff_pct?: Maybe<Scalars['Int']['output']>;
  total_questions: Scalars['Int']['output'];
  total_questions_diff_pct?: Maybe<Scalars['Int']['output']>;
  total_silence_duration: Scalars['Float']['output'];
  total_silence_duration_diff_pct?: Maybe<Scalars['Int']['output']>;
};

export type TeamMeetingStats = {
  __typename?: 'TeamMeetingStats';
  average_count: Scalars['Int']['output'];
  average_count_diff_pct?: Maybe<Scalars['Int']['output']>;
  average_duration: Scalars['Int']['output'];
  average_duration_diff_pct?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  count_diff_pct?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Float']['output'];
  duration_diff_pct?: Maybe<Scalars['Int']['output']>;
};

export type Transcript = {
  __typename?: 'Transcript';
  analytics?: Maybe<MeetingAnalytics>;
  apps_preview?: Maybe<Apps>;
  audio_url?: Maybe<Scalars['String']['output']>;
  cal_id?: Maybe<Scalars['String']['output']>;
  calendar_id?: Maybe<Scalars['String']['output']>;
  calendar_type?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Float']['output']>;
  dateString?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  fireflies_users?: Maybe<Array<Scalars['String']['output']>>;
  host_email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  meeting_attendees?: Maybe<Array<MeetingAttendeeModel>>;
  meeting_info?: Maybe<MeetingInfo>;
  meeting_link?: Maybe<Scalars['String']['output']>;
  organizer_email?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Scalars['String']['output']>>;
  privacy?: Maybe<Scalars['String']['output']>;
  sentences?: Maybe<Array<Sentence>>;
  speakers?: Maybe<Array<Speaker>>;
  summary?: Maybe<Summary>;
  title?: Maybe<Scalars['String']['output']>;
  transcript_url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  video_url?: Maybe<Scalars['String']['output']>;
};

export type UpdateMeetingTitleInput = {
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  integrations?: Maybe<Array<Scalars['String']['output']>>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  minutes_consumed?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_transcripts?: Maybe<Scalars['Float']['output']>;
  recent_meeting?: Maybe<Scalars['String']['output']>;
  recent_transcript?: Maybe<Scalars['String']['output']>;
  user_groups?: Maybe<Array<UserGroup>>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type UserAnalytics = {
  __typename?: 'UserAnalytics';
  conversation: UserConversationStats;
  meeting: UserMeetingStats;
  user_email: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  user_name: Scalars['String']['output'];
};

export type UserConversationStats = {
  __typename?: 'UserConversationStats';
  talk_listen_pct: Scalars['Float']['output'];
  talk_listen_ratio: Scalars['Float']['output'];
  total_silence_duration: Scalars['Float']['output'];
  total_silence_duration_compare_to?: Maybe<Scalars['Float']['output']>;
  total_silence_pct: Scalars['Float']['output'];
  total_silence_ratio: Scalars['Float']['output'];
  total_speak_duration: Scalars['Float']['output'];
  total_speak_duration_with_user: Scalars['Float']['output'];
  total_word_count: Scalars['Int']['output'];
  user_filler_words: Scalars['Int']['output'];
  user_filler_words_compare_to: Scalars['Int']['output'];
  user_filler_words_diff_pct?: Maybe<Scalars['Int']['output']>;
  user_longest_monologue_compare_to: Scalars['Int']['output'];
  user_longest_monologue_diff_pct?: Maybe<Scalars['Int']['output']>;
  user_longest_monologue_sec: Scalars['Int']['output'];
  user_monologues_count: Scalars['Int']['output'];
  user_monologues_count_compare_to: Scalars['Int']['output'];
  user_monologues_count_diff_pct?: Maybe<Scalars['Int']['output']>;
  user_questions: Scalars['Int']['output'];
  user_questions_compare_to: Scalars['Int']['output'];
  user_questions_diff_pct?: Maybe<Scalars['Int']['output']>;
  user_speak_duration: Scalars['Float']['output'];
  user_word_count: Scalars['Int']['output'];
  user_words_per_minute: Scalars['Int']['output'];
  user_words_per_minute_compare_to: Scalars['Int']['output'];
  user_words_per_minute_diff_pct?: Maybe<Scalars['Int']['output']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  handle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserMeetingStats = {
  __typename?: 'UserMeetingStats';
  count: Scalars['Int']['output'];
  count_diff: Scalars['Int']['output'];
  count_diff_compared_to: Scalars['Int']['output'];
  count_diff_pct?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Float']['output'];
  duration_diff: Scalars['Int']['output'];
  duration_diff_compared_to: Scalars['Int']['output'];
  duration_diff_pct?: Maybe<Scalars['Int']['output']>;
};

export type CreateBiteMutationVariables = Exact<{
  transcript_Id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  start_time: Scalars['Float']['input'];
  end_time: Scalars['Float']['input'];
  media_type?: InputMaybe<Scalars['String']['input']>;
  privacies?: InputMaybe<Array<BitePrivacy> | BitePrivacy>;
  summary?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateBiteMutation = {
  __typename?: 'Mutation';
  createBite: {
    __typename?: 'Bite';
    id: string;
    name: string;
    transcript_id: string;
    start_time: number;
    end_time: number;
    created_at?: string | null;
    status?: string | null;
    summary?: string | null;
    user_id: string;
    media_type?: string | null;
    thumbnail?: string | null;
    preview?: string | null;
    summary_status?: string | null;
    user: {
      __typename?: 'BiteUser';
      id: string;
      name: string;
      first_name?: string | null;
      last_name?: string | null;
      picture?: string | null;
    };
  };
};

export type DeleteTranscriptMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteTranscriptMutation = {
  __typename?: 'Mutation';
  deleteTranscript: {
    __typename?: 'Transcript';
    id?: string | null;
    title?: string | null;
    date?: number | null;
    duration?: number | null;
  };
};

export type UploadAudioMutationVariables = Exact<{
  input?: InputMaybe<AudioUploadInput>;
}>;

export type UploadAudioMutation = {
  __typename?: 'Mutation';
  uploadAudio: {
    __typename?: 'AudioUploadStatus';
    success: boolean;
    title: string;
    message: string;
  };
};

export type AddToLiveMeetingMutationVariables = Exact<{
  meeting_link: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  meeting_password?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Array<AttendeeInput> | AttendeeInput>;
}>;

export type AddToLiveMeetingMutation = {
  __typename?: 'Mutation';
  addToLiveMeeting: { __typename?: 'AddToLiveMeeting'; success: boolean; message: string };
};

export type SetUserRoleMutationVariables = Exact<{
  user_id: Scalars['String']['input'];
  role: Role;
}>;

export type SetUserRoleMutation = {
  __typename?: 'Mutation';
  setUserRole: {
    __typename?: 'User';
    user_id?: string | null;
    name?: string | null;
    email?: string | null;
    is_admin?: boolean | null;
  };
};

export type UpdateMeetingTitleMutationVariables = Exact<{
  input: UpdateMeetingTitleInput;
}>;

export type UpdateMeetingTitleMutation = {
  __typename?: 'Mutation';
  updateMeetingTitle: {
    __typename?: 'Transcript';
    id?: string | null;
    title?: string | null;
    date?: number | null;
    duration?: number | null;
  };
};

export type TranscriptsQueryVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Float']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  host_email?: InputMaybe<Scalars['String']['input']>;
  organizer_email?: InputMaybe<Scalars['String']['input']>;
  participant_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TranscriptsQuery = {
  __typename?: 'Query';
  transcripts?: Array<{
    __typename?: 'Transcript';
    id?: string | null;
    title?: string | null;
    date?: number | null;
    duration?: number | null;
    participants?: Array<string> | null;
    summary?: {
      __typename?: 'Summary';
      keywords?: Array<string> | null;
      action_items?: string | null;
      outline?: string | null;
      shorthand_bullet?: string | null;
      overview?: string | null;
      bullet_gist?: string | null;
    } | null;
    user?: {
      __typename?: 'User';
      user_id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    meeting_attendees?: Array<{
      __typename?: 'MeetingAttendeeModel';
      displayName?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      name?: string | null;
      location?: string | null;
    }> | null;
  }> | null;
};

export type TranscriptQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type TranscriptQuery = {
  __typename?: 'Query';
  transcript?: {
    __typename?: 'Transcript';
    id?: string | null;
    title?: string | null;
    date?: number | null;
    duration?: number | null;
    participants?: Array<string> | null;
    summary?: {
      __typename?: 'Summary';
      keywords?: Array<string> | null;
      action_items?: string | null;
      outline?: string | null;
      shorthand_bullet?: string | null;
      overview?: string | null;
      bullet_gist?: string | null;
      gist?: string | null;
      short_summary?: string | null;
      short_overview?: string | null;
      meeting_type?: string | null;
      topics_discussed?: Array<string> | null;
      transcript_chapters?: Array<string> | null;
    } | null;
    sentences?: Array<{
      __typename?: 'Sentence';
      text?: string | null;
      speaker_name?: string | null;
      speaker_id?: number | null;
      start_time?: number | null;
      end_time?: number | null;
      raw_text?: string | null;
      index?: number | null;
    }> | null;
    user?: {
      __typename?: 'User';
      user_id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    meeting_attendees?: Array<{
      __typename?: 'MeetingAttendeeModel';
      displayName?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      name?: string | null;
      location?: string | null;
    }> | null;
    speakers?: Array<{ __typename?: 'Speaker'; id?: number | null; name?: string | null }> | null;
  } | null;
};

export type UserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;

export type UserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    user_id?: string | null;
    name?: string | null;
    email?: string | null;
    num_transcripts?: number | null;
    integrations?: Array<string> | null;
    is_admin?: boolean | null;
    minutes_consumed?: number | null;
    recent_transcript?: string | null;
    recent_meeting?: string | null;
    user_groups?: Array<{
      __typename?: 'UserGroup';
      name: string;
      handle: string;
      id: string;
    }> | null;
  } | null;
};

export type AppsQueryVariables = Exact<{
  app_id?: InputMaybe<Scalars['String']['input']>;
  transcript_id?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type AppsQuery = {
  __typename?: 'Query';
  apps?: {
    __typename?: 'Apps';
    outputs?: Array<{
      __typename?: 'AppOutput';
      transcript_id?: string | null;
      user_id?: string | null;
      app_id?: string | null;
      created_at?: number | null;
      title?: string | null;
      prompt?: string | null;
      response?: string | null;
    }> | null;
  } | null;
};

export type BitesQueryVariables = Exact<{
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  transcript_id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  my_team?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;

export type BitesQuery = {
  __typename?: 'Query';
  bites: Array<{
    __typename?: 'Bite';
    id: string;
    name: string;
    transcript_id: string;
    start_time: number;
    end_time: number;
    created_at?: string | null;
    status?: string | null;
    summary?: string | null;
    user_id: string;
    media_type?: string | null;
    thumbnail?: string | null;
    preview?: string | null;
    summary_status?: string | null;
    user: {
      __typename?: 'BiteUser';
      id: string;
      name: string;
      first_name?: string | null;
      last_name?: string | null;
      picture?: string | null;
    };
    created_from?: {
      __typename?: 'BiteOrigin';
      id: string;
      name: string;
      type: BiteOriginType;
      description?: string | null;
      duration?: number | null;
    } | null;
  }>;
};

export type BiteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BiteQuery = {
  __typename?: 'Query';
  bite?: {
    __typename?: 'Bite';
    id: string;
    name: string;
    transcript_id: string;
    start_time: number;
    end_time: number;
    created_at?: string | null;
    status?: string | null;
    summary?: string | null;
    user_id: string;
    media_type?: string | null;
    thumbnail?: string | null;
    preview?: string | null;
    summary_status?: string | null;
    privacies: Array<BitePrivacy>;
    user: {
      __typename?: 'BiteUser';
      id: string;
      name: string;
      first_name?: string | null;
      last_name?: string | null;
      picture?: string | null;
    };
    captions?: Array<{
      __typename?: 'BiteCaption';
      end_time: number;
      index: number;
      speaker_id: string;
      speaker_name: string;
      start_time: number;
      text: string;
    }> | null;
    sources?: Array<{ __typename?: 'MediaSource'; src: string; type: string }> | null;
    created_from?: {
      __typename?: 'BiteOrigin';
      id: string;
      name: string;
      type: BiteOriginType;
      description?: string | null;
      duration?: number | null;
    } | null;
  } | null;
};

export type AnalyticsQueryVariables = Exact<{
  start_time?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
}>;

export type AnalyticsQuery = {
  __typename?: 'Query';
  analytics: {
    __typename?: 'Analytics';
    team: {
      __typename?: 'TeamAnalytics';
      meeting: {
        __typename?: 'TeamMeetingStats';
        count: number;
        count_diff_pct?: number | null;
        duration: number;
        duration_diff_pct?: number | null;
        average_count: number;
        average_count_diff_pct?: number | null;
        average_duration: number;
        average_duration_diff_pct?: number | null;
      };
      conversation: {
        __typename?: 'TeamConversationStats';
        average_filler_words: number;
        average_filler_words_diff_pct?: number | null;
        average_monologues_count: number;
        average_monologues_count_diff_pct?: number | null;
        average_questions: number;
        average_questions_diff_pct?: number | null;
        average_silence_duration: number;
        average_silence_duration_diff_pct?: number | null;
        average_talk_listen_ratio: number;
        average_words_per_minute: number;
        longest_monologue_duration_sec: number;
        longest_monologue_duration_diff_pct?: number | null;
        total_filler_words: number;
        total_filler_words_diff_pct?: number | null;
        total_meeting_notes_count: number;
        total_meetings_count: number;
        total_monologues_count: number;
        total_monologues_diff_pct?: number | null;
        teammates_count: number;
        total_questions: number;
        total_questions_diff_pct?: number | null;
        total_silence_duration: number;
        total_silence_duration_diff_pct?: number | null;
      };
    };
    users: Array<{
      __typename?: 'UserAnalytics';
      user_id: string;
      user_name: string;
      user_email: string;
      meeting: {
        __typename?: 'UserMeetingStats';
        count: number;
        count_diff: number;
        count_diff_compared_to: number;
        count_diff_pct?: number | null;
        duration: number;
        duration_diff: number;
        duration_diff_compared_to: number;
        duration_diff_pct?: number | null;
      };
      conversation: {
        __typename?: 'UserConversationStats';
        talk_listen_pct: number;
        talk_listen_ratio: number;
        total_silence_duration: number;
        total_silence_duration_compare_to?: number | null;
        total_silence_pct: number;
        total_silence_ratio: number;
        total_speak_duration: number;
        total_speak_duration_with_user: number;
        total_word_count: number;
        user_filler_words: number;
        user_filler_words_compare_to: number;
        user_filler_words_diff_pct?: number | null;
        user_longest_monologue_sec: number;
        user_longest_monologue_compare_to: number;
        user_longest_monologue_diff_pct?: number | null;
        user_monologues_count: number;
        user_monologues_count_compare_to: number;
        user_monologues_count_diff_pct?: number | null;
        user_questions: number;
        user_questions_compare_to: number;
        user_questions_diff_pct?: number | null;
        user_speak_duration: number;
        user_word_count: number;
        user_words_per_minute: number;
        user_words_per_minute_compare_to: number;
        user_words_per_minute_diff_pct?: number | null;
      };
    }>;
  };
};

export const CreateBiteDocument = gql`
  mutation CreateBite(
    $transcript_Id: ID!
    $name: String
    $start_time: Float!
    $end_time: Float!
    $media_type: String
    $privacies: [BitePrivacy!]
    $summary: String
  ) {
    createBite(
      transcript_Id: $transcript_Id
      name: $name
      start_time: $start_time
      end_time: $end_time
      media_type: $media_type
      privacies: $privacies
      summary: $summary
    ) {
      id
      name
      transcript_id
      start_time
      end_time
      created_at
      status
      summary
      user_id
      media_type
      thumbnail
      preview
      summary_status
      user {
        id
        name
        first_name
        last_name
        picture
      }
    }
  }
`;
export const DeleteTranscriptDocument = gql`
  mutation DeleteTranscript($id: String!) {
    deleteTranscript(id: $id) {
      id
      title
      date
      duration
    }
  }
`;
export const UploadAudioDocument = gql`
  mutation UploadAudio($input: AudioUploadInput) {
    uploadAudio(input: $input) {
      success
      title
      message
    }
  }
`;
export const AddToLiveMeetingDocument = gql`
  mutation AddToLiveMeeting(
    $meeting_link: String!
    $title: String
    $meeting_password: String
    $duration: Int
    $language: String
    $attendees: [AttendeeInput!]
  ) {
    addToLiveMeeting(
      meeting_link: $meeting_link
      title: $title
      meeting_password: $meeting_password
      duration: $duration
      language: $language
      attendees: $attendees
    ) {
      success
      message
    }
  }
`;
export const SetUserRoleDocument = gql`
  mutation SetUserRole($user_id: String!, $role: Role!) {
    setUserRole(user_id: $user_id, role: $role) {
      user_id
      name
      email
      is_admin
    }
  }
`;
export const UpdateMeetingTitleDocument = gql`
  mutation UpdateMeetingTitle($input: UpdateMeetingTitleInput!) {
    updateMeetingTitle(input: $input) {
      id
      title
      date
      duration
    }
  }
`;
export const TranscriptsDocument = gql`
  query Transcripts(
    $title: String
    $keyword: String
    $scope: String
    $date: Float
    $fromDate: DateTime
    $toDate: DateTime
    $limit: Int
    $skip: Int
    $host_email: String
    $organizer_email: String
    $participant_email: String
    $user_id: String
    $mine: Boolean
  ) {
    transcripts(
      title: $title
      keyword: $keyword
      scope: $scope
      date: $date
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      skip: $skip
      host_email: $host_email
      organizer_email: $organizer_email
      participant_email: $participant_email
      user_id: $user_id
      mine: $mine
    ) {
      id
      title
      date
      duration
      summary {
        keywords
        action_items
        outline
        shorthand_bullet
        overview
        bullet_gist
      }
      user {
        user_id
        name
        email
      }
      participants
      meeting_attendees {
        displayName
        email
        phoneNumber
        name
        location
      }
    }
  }
`;
export const TranscriptDocument = gql`
  query Transcript($id: String!) {
    transcript(id: $id) {
      id
      title
      date
      duration
      summary {
        keywords
        action_items
        outline
        shorthand_bullet
        overview
        bullet_gist
        gist
        short_summary
        short_overview
        meeting_type
        topics_discussed
        transcript_chapters
      }
      sentences {
        text
        speaker_name
        speaker_id
        start_time
        end_time
        raw_text
        index
      }
      user {
        user_id
        name
        email
      }
      participants
      meeting_attendees {
        displayName
        email
        phoneNumber
        name
        location
      }
      speakers {
        id
        name
      }
    }
  }
`;
export const UserDocument = gql`
  query User($id: String) {
    user(id: $id) {
      user_id
      name
      email
      num_transcripts
      integrations
      is_admin
      minutes_consumed
      recent_transcript
      recent_meeting
      user_groups {
        name
        handle
        id
      }
    }
  }
`;
export const AppsDocument = gql`
  query Apps($app_id: String, $transcript_id: String, $skip: Float, $limit: Float) {
    apps(app_id: $app_id, transcript_id: $transcript_id, skip: $skip, limit: $limit) {
      outputs {
        transcript_id
        user_id
        app_id
        created_at
        title
        prompt
        response
      }
    }
  }
`;
export const BitesDocument = gql`
  query Bites($mine: Boolean, $transcript_id: ID, $limit: Int, $my_team: Boolean, $skip: Int) {
    bites(
      mine: $mine
      transcript_id: $transcript_id
      limit: $limit
      my_team: $my_team
      skip: $skip
    ) {
      id
      name
      transcript_id
      start_time
      end_time
      created_at
      status
      summary
      user_id
      media_type
      thumbnail
      preview
      summary_status
      user {
        id
        name
        first_name
        last_name
        picture
      }
      created_from {
        id
        name
        type
        description
        duration
      }
    }
  }
`;
export const BiteDocument = gql`
  query Bite($id: ID!) {
    bite(id: $id) {
      id
      name
      transcript_id
      start_time
      end_time
      created_at
      status
      summary
      user_id
      media_type
      thumbnail
      preview
      summary_status
      user {
        id
        name
        first_name
        last_name
        picture
      }
      captions {
        end_time
        index
        speaker_id
        speaker_name
        start_time
        text
      }
      sources {
        src
        type
      }
      privacies
      created_from {
        id
        name
        type
        description
        duration
      }
    }
  }
`;
export const AnalyticsDocument = gql`
  query Analytics($start_time: String, $end_time: String) {
    analytics(start_time: $start_time, end_time: $end_time) {
      team {
        meeting {
          count
          count_diff_pct
          duration
          duration_diff_pct
          average_count
          average_count_diff_pct
          average_duration
          average_duration_diff_pct
        }
        conversation {
          average_filler_words
          average_filler_words_diff_pct
          average_monologues_count
          average_monologues_count_diff_pct
          average_questions
          average_questions_diff_pct
          average_silence_duration
          average_silence_duration_diff_pct
          average_talk_listen_ratio
          average_words_per_minute
          longest_monologue_duration_sec
          longest_monologue_duration_diff_pct
          total_filler_words
          total_filler_words_diff_pct
          total_meeting_notes_count
          total_meetings_count
          total_monologues_count
          total_monologues_diff_pct
          teammates_count
          total_questions
          total_questions_diff_pct
          total_silence_duration
          total_silence_duration_diff_pct
        }
      }
      users {
        user_id
        user_name
        user_email
        meeting {
          count
          count_diff
          count_diff_compared_to
          count_diff_pct
          duration
          duration_diff
          duration_diff_compared_to
          duration_diff_pct
        }
        conversation {
          talk_listen_pct
          talk_listen_ratio
          total_silence_duration
          total_silence_duration_compare_to
          total_silence_pct
          total_silence_ratio
          total_speak_duration
          total_speak_duration_with_user
          total_word_count
          user_filler_words
          user_filler_words_compare_to
          user_filler_words_diff_pct
          user_longest_monologue_sec
          user_longest_monologue_compare_to
          user_longest_monologue_diff_pct
          user_monologues_count
          user_monologues_count_compare_to
          user_monologues_count_diff_pct
          user_questions
          user_questions_compare_to
          user_questions_diff_pct
          user_speak_duration
          user_word_count
          user_words_per_minute
          user_words_per_minute_compare_to
          user_words_per_minute_diff_pct
        }
      }
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) =>
  action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CreateBite(
      variables: CreateBiteMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<CreateBiteMutation> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<CreateBiteMutation>({
            document: CreateBiteDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'CreateBite',
        'mutation',
        variables
      );
    },
    DeleteTranscript(
      variables: DeleteTranscriptMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<DeleteTranscriptMutation> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<DeleteTranscriptMutation>({
            document: DeleteTranscriptDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'DeleteTranscript',
        'mutation',
        variables
      );
    },
    UploadAudio(
      variables?: UploadAudioMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<UploadAudioMutation> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<UploadAudioMutation>({
            document: UploadAudioDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'UploadAudio',
        'mutation',
        variables
      );
    },
    AddToLiveMeeting(
      variables: AddToLiveMeetingMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<AddToLiveMeetingMutation> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<AddToLiveMeetingMutation>({
            document: AddToLiveMeetingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'AddToLiveMeeting',
        'mutation',
        variables
      );
    },
    SetUserRole(
      variables: SetUserRoleMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<SetUserRoleMutation> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<SetUserRoleMutation>({
            document: SetUserRoleDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'SetUserRole',
        'mutation',
        variables
      );
    },
    UpdateMeetingTitle(
      variables: UpdateMeetingTitleMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<UpdateMeetingTitleMutation> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<UpdateMeetingTitleMutation>({
            document: UpdateMeetingTitleDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'UpdateMeetingTitle',
        'mutation',
        variables
      );
    },
    Transcripts(
      variables?: TranscriptsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<TranscriptsQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<TranscriptsQuery>({
            document: TranscriptsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'Transcripts',
        'query',
        variables
      );
    },
    Transcript(
      variables: TranscriptQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<TranscriptQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<TranscriptQuery>({
            document: TranscriptDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'Transcript',
        'query',
        variables
      );
    },
    User(
      variables?: UserQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<UserQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<UserQuery>({
            document: UserDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'User',
        'query',
        variables
      );
    },
    Apps(
      variables?: AppsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<AppsQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<AppsQuery>({
            document: AppsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'Apps',
        'query',
        variables
      );
    },
    Bites(
      variables?: BitesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<BitesQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<BitesQuery>({
            document: BitesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'Bites',
        'query',
        variables
      );
    },
    Bite(
      variables: BiteQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<BiteQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<BiteQuery>({
            document: BiteDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'Bite',
        'query',
        variables
      );
    },
    Analytics(
      variables?: AnalyticsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<AnalyticsQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<AnalyticsQuery>({
            document: AnalyticsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'Analytics',
        'query',
        variables
      );
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;
